module.exports = __webpack_public_path__ + "static/media/workflow-empty.e67d1c17.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/workflow-empty.png
// module id = 2660
// module chunks = 17